// extracted by mini-css-extract-plugin
export var ResponsivePlayer_playerWrapper = "responsivePlayer-module--ResponsivePlayer_playerWrapper--0cf21";
export var ResponsivePlayer_reactPlayer = "responsivePlayer-module--ResponsivePlayer_reactPlayer--4f29e";
export var slideIn = "responsivePlayer-module--slide-in--a096d";
export var slideInFromRight = "responsivePlayer-module--slide-in-from-right--dc370";